import { render, staticRenderFns } from "./MovieList.vue?vue&type=template&id=3be1fe3a&scoped=true"
import script from "./MovieList.vue?vue&type=script&lang=js"
export * from "./MovieList.vue?vue&type=script&lang=js"
import style0 from "./MovieList.vue?vue&type=style&index=0&id=3be1fe3a&prod&scoped=true&lang=css"
import style1 from "./MovieList.vue?vue&type=style&index=1&id=3be1fe3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be1fe3a",
  null
  
)

export default component.exports